import React from 'react';
import Table from '../../components/Table/Table';
import UpsideBadge from '../../components/UpsideBadge/UpsideBadge';
import { formatCurrency } from '../../helpers/format';
import style from './TargetPriceList.module.css';

const TargetPriceList = ({ price_targets, price }) => {
  return (
    <div className={style.tableContainer}>
      <Table>
        <thead>
          <tr>
            <th width="110">Date</th>
            <th>Analyst</th>
            <th>Price Target</th>
            <th>Current Upside/Downside</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {price_targets.map((price_target, index) => {
            return (
              <tr key={index}>
                <td>{price_target.published_date}</td>
                <td>
                  {price_target.analyst_company}
                  { price_target.analyst_name && 
                    <span className={style.analystName}>{price_target.analyst_name}</span>
                  }
                </td>
                <td>${formatCurrency(price_target.adj_price_target)}</td>
                <td>
                  <UpsideBadge change={calcChange(price_target, price).toFixed(1)} subtle />
                </td>
                <td>
                  <a href={price_target.news_url} title={price_target.news_title} target="_blank" rel="noreferrer noopener">
                    <img src="/react/phosphor/arrow-square-out.svg" alt="Open" width="16" height="16" />
                  </a>
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    </div>
  )
}

export default TargetPriceList;

function calcChange(price_target, price) {
  return (price_target.adj_price_target - price) / price * 100;
}